import { useQuery } from "@tanstack/react-query";
import { api } from "../api/client";

export interface ProxyInfo {
  enabled: boolean;
  provider: string;
  defaultCountry: string;
  stickyLifetimeMin: number;
  supportedCountries: string[];
}

/**
 * Fetches the platform's managed-proxy configuration. Used to render the
 * "Routed via managed proxy" banner + the country dropdown in account forms.
 *
 * The endpoint is cheap and the answer rarely changes, so we cache aggressively.
 */
export function useProxyInfo() {
  return useQuery<ProxyInfo>({
    queryKey: ["proxy-info"],
    queryFn: async () => {
      const { data } = await api.get<ProxyInfo>(
        "/api/instagram-accounts/proxy/info"
      );
      return data;
    },
    staleTime: 5 * 60 * 1000,
    gcTime: 30 * 60 * 1000,
  });
}
